import { useEffect } from 'react';
import PropTypes from 'prop-types';
import updateEstimateURL from '../helpers/updateEstimateURL';

const SessionLoader = ({ loadSession, match: { params } }) => {
  const { sessionId } = params;
  const designId = new URLSearchParams(location.search).get('designId');

  useEffect(() => {
    if (sessionId) {
      loadSession(sessionId, { designToAttach: designId }).then(updateEstimateURL);
    }
  }, [sessionId, designId]);

  return null;
};
SessionLoader.propTypes = {
  loadSession: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({}).isRequired,
  }).isRequired,
};
export default SessionLoader;
